<template>
  <div class="ueditor-box">
    <vue-ueditor-wrap
      class="ueditor-wrap"
      :style="preview ? 'width:50%':'width:100%'"
      ref="ueditor"
      v-model="currentValue"
      :config="config"
      :destroy="true"
      :init="init"
    />
    <el-card v-if="preview" shadow="never" class="card-box">
      <template slot="header">预览</template>
      <div v-html="currentValue" class="card-item"></div>
    </el-card>
  </div>
</template>

<script>
// 参考 https://github.com/HaoChuan9421/vue-ueditor-wrap
import config from "./ueditor.config";

export default {
  props: {
    value: {
      type: String,
      default: ""
    },
    zIndex:{
      type:Number,
      default:900
    },
    preview: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      config,
      currentValue: ""
    };
  },
  watch: {
    // 对外提供 v-model
    value: {
      handler(val) {
        if (this.currentValue !== val) {
          this.currentValue = val;
        }
      },
      immediate: true
    },
    // 对外提供 v-model
    currentValue(val) {
      this.$emit("input", val);
    },
    zIndex: {
      handler(val) {
        this.config.zIndex = val
      },
      immediate: true
    },
  },
  methods: {
    init() {}
  }
};
</script>
<style lang="scss">
.ueditor-box {
  display: flex;
  width: 100%;
  line-height: 1.15;
  .ueditor-wrap {
    margin-right: 20px;
  }
  .card-box {
    border: 1px solid #d4d4d4;
    width: 50%;
    overflow-y: auto;
    height: 530px;
    .card-item {
      line-height: 1.15;
      p {
        margin: 0;
        padding: 0;

        img {
          max-width: 100%;
        }
      }
    }
  }
}
</style>
